import { Button } from "@/components/ui/button";
import rocketImage from "@/assets/raket-1000px.jpg";

const AILyftet = () => {
  return (
    <section className="py-20 px-6 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Content - LEFT side */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-foreground">
              AI-Lyftet
            </h2>
            
            <div className="space-y-4 text-muted-foreground text-lg leading-relaxed">
              <p>
                AI-Lyftet is an initiative designed to improve AI skills among Swedish companies and society. Its goal is to enhance decision-making, boost efficiency, and drive innovation through AI knowledge. The program is tailored for leadership teams, AI managers, and IT or HR leaders, helping organizations create customized training plans for all employees and leaders.
              </p>
              
              <p>
                Through workshops, AI-Lyftet provides essential AI knowledge, enabling employees to get started and laying the groundwork for AI transformation. It includes practical educational activities such as courses, seminars, digital forums, leader workshops, webinars, promptathons, hackathons, and other events. The initiative also focuses on understanding the ethical dimensions of AI and promoting responsible use.
              </p>
            </div>
            
            <a href="https://ai-lyftet.se/" target="_blank" rel="noopener noreferrer">
              <Button variant="secondary" size="lg" className="mt-4">
                Read more →
              </Button>
            </a>
          </div>
          
          {/* Image - RIGHT side */}
          <div className="relative">
            <img 
              src={rocketImage} 
              alt="AI-Lyftet rocket launch visualization" 
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AILyftet;
